import React from 'react';
import { Helmet } from 'react-helmet-async';
import WorldClock from '../components/world_clock_component';
import { getCanonicalUrl } from '../utils/seoUtils';

export default function WorldClockPage() {
  return (
    <div className="space-y-8">
      <Helmet>
        <title>World Clock Online - Multiple Time Zones | Clock Online</title>
        <meta name="description" content="View multiple time zones simultaneously with our free online world clock. Track time across different countries and cities worldwide. Perfect for global scheduling." />
        <link rel="canonical" href={getCanonicalUrl('/world-clock')} />
        <meta property="og:title" content="World Clock Online - Multiple Time Zones | Clock Online" />
        <meta property="og:description" content="View multiple time zones simultaneously with our free online world clock. Track time across different countries and cities." />
        <meta property="og:url" content={getCanonicalUrl('/world-clock')} />
        <meta name="twitter:title" content="World Clock Online - Multiple Time Zones | Clock Online" />
        <meta name="twitter:description" content="View multiple time zones simultaneously with our free online world clock." />
      </Helmet>
      {/* Page Header */}
      <div className="text-center">
        <h1 className="text-4xl font-bold text-white mb-4">
          World Clock
        </h1>
        <p className="text-cyan-200 text-lg max-w-2xl mx-auto">
          Keep track of time zones around the world. Perfect for scheduling international meetings and staying connected with friends and family across the globe.
        </p>
      </div>

      {/* World Clock Component */}
      <WorldClock />
    </div>
  );
}